import { render, staticRenderFns } from "./PlanejamentoOrdemDeServicoCubagem.vue?vue&type=template&id=50cb5d51&scoped=true"
import script from "./PlanejamentoOrdemDeServicoCubagem.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanejamentoOrdemDeServicoCubagem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PlanejamentoOrdemDeServicoCubagem.vue?vue&type=style&index=0&id=50cb5d51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb5d51",
  null
  
)

export default component.exports